import {Alert, Button, Grid} from "@mui/material";
import { QueryStatus } from "src/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { SubmitHandler, useForm } from "react-hook-form";
import { useContext, useEffect } from "react";
import { useLoader } from "src/hooks/useLoader";
import { ContextOperacion, ContextOperacionType } from "../../RefactorLayout";
import { useOperacionCLG } from "./hooks/useOperacionCLG";
import SeccionCLGDatosOperacion from "./components/SeccionCLGDatosOperacion";
import { SeccionFirmas } from "../../components/SeccionFirmas";
import { FormOperacionCLG, OperacionCLG, schemaFormOperacionCLG } from "./types/types";
import SeccionCLGDatosDetalle from "./components/SeccionCLGDatosDetalle";
import toast from "react-hot-toast";
import { HttpCLG } from "./api/HttpCLG";
import {SistemaTipo} from "../../../../types/enum/enum";


type SistemaCLGarantiaContentProps = {
    operacion: OperacionCLG,
}

const SistemaCLGarantiaContent = ({ operacion }: SistemaCLGarantiaContentProps) => {

    const { setSavePromise, codSistemaTipo: codSistema } = useContext<ContextOperacionType>(ContextOperacion)

    const formMethods = useForm<FormOperacionCLG>({
        resolver: zodResolver(schemaFormOperacionCLG),
        values: { ...operacion }
    })

    const { showLoader, hideLoader } = useLoader()


    useEffect(() => {
        if (operacion.permiteEditarOperacion) {
            const handleSave: SubmitHandler<FormOperacionCLG> = (data) => {
                showLoader()
                const promise = HttpCLG.put(operacion.id, data)

                toast.promise(promise, {
                    loading: 'Guardando.',
                    success: 'Guardado correctamente.',
                    error: e => `${e}`
                }).finally(hideLoader)
            }

            const onSave = () => formMethods.handleSubmit(handleSave)
            setSavePromise(onSave)
        }
    }, [])

    return (
        <>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <SeccionCLGDatosOperacion
                        codSistemaPrincipal={operacion.codPais}
                        codSistema={codSistema}
                        formMethods={formMethods}
                        operacion={operacion}
                        readOnly={!operacion.permiteEditarOperacion}
                    />
                </Grid>
                <Grid item xs={12}>
                    <SeccionCLGDatosDetalle
                        operacion={operacion} />
                </Grid>
                <Grid item xs={12}>
                    <Grid item xs={12}>
                        <SeccionFirmas
                            codSistema={SistemaTipo.CLG}
                            idOperacion={operacion.id}
                        />
                    </Grid>
                </Grid>

            </Grid>
        </>
    )
}


const SistemaCLGarantia = () => {

    const { idOperacion, setSavePromise } = useContext<ContextOperacionType>(ContextOperacion)

    const { status, operacion } = useOperacionCLG(idOperacion)

    const { showLoader, hideLoader } = useLoader()

    useEffect(() => {
        if (status === QueryStatus.Loading) {
            showLoader()
        } else {
            hideLoader();
        }
    }, [status])

    if (!operacion) {
        return (
            <></>
        )
    }

    if (status === QueryStatus.Error) {
        return (
            <Alert severity='error'>
                Se produjo un error al cargar la operación.
            </Alert>
        )
    }

    return (
        <SistemaCLGarantiaContent
            operacion={operacion}
        />
    )
}

export default SistemaCLGarantia;
